/** Clamp value between min and max */
export function clamp(value: number, min: number, max: number): number {
  return Math.max(min, Math.min(max, value));
}

/** Linear interpolation */
export function lerp(a: number, b: number, t: number): number {
  return a + (b - a) * t;
}

/** Inverse square falloff: returns 0-1 value based on distance and radius */
export function inverseSquareFalloff(distance: number, radius: number): number {
  if (distance >= radius) return 0;
  if (distance <= 0) return 1;
  const normalized = distance / radius;
  return 1 - normalized * normalized;
}
